import { Injectable, inject } from '@angular/core';
import { catchError, Observable } from 'rxjs';
import { CustomService } from '@/shared/services/custom.service';
import { Pessoa } from '@/shared/models/pessoa-info.model';
import { TelemedicinaService } from '@/core/api/sicom-api/registro/medico/telemedicina/telemedicina.service';
import { MedicoTelemedicinaHistoricoResponse, MedicoTelemedicinaResponse, TipoTelemedicinaResponse } from '@/core/api/sicom-api/registro/medico/telemedicina/telemedicina.model';

@Injectable({ providedIn: 'root' })
/** Fachada de telemedicina do médico. */
export class TelemedicinaFeatureService extends CustomService {
    private readonly core = inject(TelemedicinaService);

    buscar(params: Pessoa): Observable<MedicoTelemedicinaResponse[]> {
        return this.core.buscar(params).pipe(catchError(this.handleError));
    }

    buscarHistorico(params: Pessoa): Observable<MedicoTelemedicinaHistoricoResponse[]> {
        return this.core.buscarHistorico(params).pipe(catchError(this.handleError));
    }

    listarTiposTelemedicina(): Observable<TipoTelemedicinaResponse[]> {
        return this.core.listarTiposTelemedicina().pipe(catchError(this.handleError));
    }

    inserirTelemedicina(body: MedicoTelemedicinaResponse): Observable<void> {
        return this.core.inserirTelemedicina(body).pipe(catchError(this.handleError));
    }

    atualizarTelemedicina(body: MedicoTelemedicinaResponse): Observable<void> {
        return this.core.atualizarTelemedicina(body).pipe(catchError(this.handleError));
    }
}
